import React, {FormEvent} from 'react';
import {observer} from 'mobx-react';
import {stylesheet} from 'typestyle';
import {spinner} from '../styles/style';
import {px} from 'csx';
import {inject, Stores} from '../inject';
import {I18n, TProvider} from '../i18n/i18n';
import {CiBlueColor, LightGreyColor, WhiteColor, GreyColor, ErrorColorFaded60} from '../styles/colors';

interface State {
    username: string;
    password: string;
}

@observer
class Login extends React.Component<Stores<'store'>, State> {
    public state: State = {username: '', password: ''};

    public render() {
        const {username, password} = this.state;
        const {
            store: {loginRequestRunning},
        } = this.props;

        const {version} = this.props.store.getVersionInfo();

        return (
            <div>
                <div className={loginCss.versionNumber}>{version}</div>
                <div className={loginCss.centeredLoginForm}>
                    <div className={loginCss.container}>
                        <TProvider>
                            {(t) => (
                                <form onSubmit={this.tryLogin}>
                                    <input
                                        className={loginCss.input}
                                        onChange={(event) => this.setState({username: event.target.value})}
                                        value={username}
                                        type="text"
                                        placeholder={t('login.username')}
                                    />
                                    <input
                                        className={loginCss.input}
                                        onChange={(event) => this.setState({password: event.target.value})}
                                        value={password}
                                        type="password"
                                        placeholder={t('login.password')}
                                    />
                                    <div>
                                        <button className={loginCss.button}>
                                            {loginRequestRunning ? (
                                                <div className={spinner(20)} />
                                            ) : (
                                                <div>
                                                    <I18n i18nKey="login.button">
                                                        Login mit <span className={loginCss.factFinder}>Fact-Finder</span>
                                                    </I18n>
                                                </div>
                                            )}
                                        </button>
                                    </div>
                                </form>
                            )}
                        </TProvider>
                    </div>
                </div>
            </div>
        );
    }

    private tryLogin = (event: FormEvent<EventTarget>) => {
        event.preventDefault();
        const {username, password} = this.state;
        this.props.store.login(username, password);
    };
}

export default inject('store')(Login);

const loginCss = stylesheet({
    versionNumber: {position: 'absolute', bottom: 0, right: 5, color: GreyColor},
    factFinder: {
        fontFamily: 'Impact, Charcoal, sans-serif',
    },
    centeredLoginForm: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translateX(-50%) translateY(-50%)',
    },
    container: {
        display: 'inline-block',
        width: 300,
    },
    input: {
        display: 'block',
        width: '100%',
        boxSizing: 'border-box',
        marginBottom: 5,
        borderRadius: 2,
        border: '1px solid ' + LightGreyColor,
        padding: 5,
    },
    button: {
        position: 'relative',
        cursor: 'pointer',
        height: 34,
        lineHeight: px(34),
        borderRadius: 2,
        border: 'none',
        color: WhiteColor,
        backgroundColor: CiBlueColor,
        width: '100%',
    },
    failedBox: {
        height: 36,
        lineHeight: px(36),
        marginTop: 5,
        background: ErrorColorFaded60,
        color: WhiteColor,
        borderRadius: 2,
    },
});



// WEBPACK FOOTER //
// ./src/views/Login.tsx